<template>
    <div class="CoverageFormat">
      <img
        src="/images/C8V8U0c.jpg"
        alt="Internet Connectivity in Dominican Republic"
        class="banner-img CoverageFormat__saturation"
      />
  
      <h1 class="CoverageFormat__title text-center">
        INTERNET SERVICES IN THE DOMINICAN REPUBLIC – A CONNECTIVITY HUB
      </h1>
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION</strong> - 10.90 million*</li>
            <li>
              <strong>NEIGHBOURING COUNTRIES</strong> - The island nation is bordered by
              <strong>Haiti</strong> in the west and shares maritime borders with Colombia, Venezuela, Aruba (Netherlands), Curacao (Netherlands), Puerto Rico (United States), and Turks and Caicos Islands (United Kingdom).
            </li>
            <li><strong>LANGUAGE SPOKEN</strong> - Spanish</li>
            <li><strong>CURRENCY</strong> - Dominican Peso</li>
            <li><strong>INDUSTRIES</strong> - Tourism, agriculture, mining, cement, tobacco, and sugar production.</li>
            <li><strong>EMPLOYMENT RATE</strong> - 56.8 percent*</li>
            <li><strong>TOP 3 CITIES</strong> - Santo Domingo, Santiago de los Caballeros, San Pedro de Macoris</li>
            <li><strong>TOURISM</strong> - Over 6.4 million* visitors annually</li>
            <li><strong>CLIMATE</strong> - Mild, tropical climate with year-round warmth.</li>
            <li><strong>SPORT</strong> - Baseball, with Dominican players making a significant impact in Major League Baseball.</li>
          </ul>
  
          <div class="text-center">
            <img
              src="https://gistcdn.githack.com/juan-bits/2f7ebb0fac50d497fb9ff946898787f7/raw/f998718d488d26056d7e04e748c5bf378fba4248/dominican-flag.svg"
              alt="Dominican Republic flag"
              class="my-5"
              style="width: 150px"
            />
          </div>
        </nav>
  
        <article>
          <p>
            The Dominican Republic is located on the island of "La Hispaniola" in the Caribbean. Discovered by Christopher Columbus in 1492, the country has evolved into the largest economy in the Caribbean and Central America region.
          </p>
          <p>
            With its strategic location, the Dominican Republic is increasingly attracting international investors, making it a key player in the region's economic and technological growth.
          </p>
  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1935300.8942961085!2d-71.25135073975223!3d18.669175595152634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eaf8838def1b6f5%3A0xa6020f24060df7e0!2sDominican%20Republic!5e0!3m2!1sen!2ses!4v1642674914005!5m2!1sen!2ses"
            width="95%"
            height="450"
            class="CoverageFormat__margins"
            style="border: 0"
            loading="lazy"
            allowfullscreen
            title="Dominican Republic Location Map"
          ></iframe>
  
          <h4 class="mt-4">Main Ports & Airports of the Dominican Republic</h4>
          <ul>
            <li>Port of Santo Domingo (DOSDQ)</li>
            <li>Port of Rio Haina (DOHAI)</li>
            <li>Port of Puerto Plata (DOPOP)</li>
            <li>Port of Barahona (DOBRX)</li>
            <li>Port of Caucedo (DOBCC)</li>
            <li>Port of Samana (DOAZS)</li>
          </ul>
        </article>
      </section>
  
      <div class="container">
        <p>
          With 7 international airports, the Dominican Republic facilitates domestic and international connectivity. Major airports include:
        </p>
        <ol>
          <li>Punta Cana International Airport</li>
          <li>Las Américas International Airport</li>
          <li>Cibao International Airport</li>
          <li>Gregorio Luperón International Airport</li>
        </ol>
  
        <h4 class="mt-5">Dominican Republic's Traditional Cuisine</h4>
        <ul>
          <li>Sancocho – a rich stew with seven types of meat</li>
          <li>La Bandera Dominicana – the national dish</li>
          <li>Mangú – mashed plantains</li>
          <li>Dominican rice</li>
          <li>Mofongo</li>
          <li>Tostones</li>
          <li>Fried fish</li>
        </ul>
  
        <h4 class="mt-5">Internet Connectivity*</h4>
        <table class="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Connection Type</th>
              <th>Millions</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Broadband users</td><td>1.03 m</td><td>9.51%</td></tr>
            <tr><td>Landlines</td><td>1.03 m</td><td>10.65%</td></tr>
            <tr><td>Mobile cellulars</td><td>8.99 m</td><td>82.87%</td></tr>
            <tr><td>Internet access</td><td>8.08 m</td><td>79% per 100 inhabitants</td></tr>
          </tbody>
        </table>
  
        <h4 class="mt-5">Submarine Cables</h4>
        <a
          href="https://www.submarinecablemap.com/country/dominican-republic"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/images/EvT9bqq.jpg"
            alt="submarine cables"
            width="100%"
          />
        </a>
        <ol class="mt-4">
          <li>AMX-1</li>
          <li>Antillas 1</li>
          <li>ARCOS</li>
          <li>Boriken Submarine Cable System (BSCS)</li>
          <li>East-West</li>
          <li>Fibralink</li>
          <li>South America-1 (SAm-1)</li>
        </ol>
  
        <h4 class="mt-4">Internet Service Providers*</h4>
        <p>
          Despite being an island nation, the Dominican Republic offers robust connectivity with seven submarine cables and a growing user base of 8.08 million.
        </p>
        <p>
          Average download speed: 13 Mbps. Upload: 7.5 Mbps. Fiber is available in 19 provinces. Wireless microwave solutions expand reach. The government continues infrastructure investment.
        </p>
        <p>
          There are 13 ISPs in total. 7 of them are partners of inte-QT.
        </p>
  
        <h4 class="mt-5">Our Key Internet Service Capabilities*</h4>
        <table class="table table-striped">
          <thead>
            <tr><th>Capabilities</th><th><i class="fas fa-check"></i></th></tr>
          </thead>
          <tbody>
            <tr><td>Dedicated Lines</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Business Broadband</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Wireless Connectivity</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>SLA (Service Level Agreements)</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>CPE / Router</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>GEMS</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Diverse Gateway Solutions</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>DDoS Protection</td><td><i class="fas fa-check"></i></td></tr>
          </tbody>
        </table>
  
        <p class="CoverageFormat__tag CoverageFormat__margins" align="justify">
          Our global business solutions team can provide a <mark>Commercial Offer in 1-2 working days</mark>. Delivery within 10–14 business days in major cities, or 4–6 weeks elsewhere.
        </p>
  
        <p class="text-center">
          For more information, please
          <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>.
        </p>
  
        <h4>* - References</h4>
        <ul>
          <li><a href="https://tradingeconomics.com/dominican-republic/" target="_blank" rel="noopener noreferrer">Reference 1</a></li>
          <li><a href="https://datatopics.worldbank.org/world-development-indicators/" target="_blank" rel="noopener noreferrer">Reference 2</a></li>
          <li><a href="https://www.statista.com/statistics/816404/dominican-republic-number-of-tourist-arrivals/" target="_blank" rel="noopener noreferrer">Reference 3</a></li>
          <li><a href="https://www.worlddata.info/america/dominican-republic/telecommunication.php" target="_blank" rel="noopener noreferrer">Reference 4</a></li>
          <li><a href="https://www.statista.com/statistics/1055456/internet-penetration-dominican-republic/" target="_blank" rel="noopener noreferrer">Reference 5</a></li>
          <li><a href="https://www.itu.int/net4/itu-d/icteye#/" target="_blank" rel="noopener noreferrer">Reference 6</a></li>
        </ul>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import GetInTouch from '@/components/GetInTouch.vue';
  
  export default {
    name: 'DominicanRepublic',
    components: {
      GetInTouch,
    },
    metaInfo() {
      return {
        title: 'Reliable Internet Services in Dominican Republic - inte-QT',
        meta: [
          {
            name: 'title',
            content: 'Reliable Internet Services in Dominican Republic - inte-QT',
          },
          {
            name: 'description',
            content:
              'Explore our internet services and coverage in Dominican Republic. Offering business broadband, dedicated lines, and more.',
          },
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://www.inte-qt.com/coverage/dominicanrepublic',
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  